/**
 * Compact AM/PM time picker. Emits a 24-hour "HH:MM" string via onChange.
 * Value is either a 24-hour "HH:MM" or full ISO ("2026-02-06T09:15:00").
 */
import { parseTimeAmPm, encodeTimeAmPm } from "../lib/attendanceStatus";

export function AmPmTimeInput({ value, onChange, testid }) {
  const { h12, mm, ampm } = parseTimeAmPm(value || "");
  const emit = (nh, nm, na) => {
    onChange?.(encodeTimeAmPm(nh, nm, na));
  };

  const hours = Array.from({ length: 12 }, (_, i) => i + 1);
  const mins = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));

  return (
    <div className="flex items-center gap-1" data-testid={testid}>
      <select
        value={h12 || ""}
        onChange={(e) => emit(e.target.value, mm || "00", ampm || "AM")}
        className="h-9 rounded-md border border-input bg-background px-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-slate-400"
        data-testid={testid ? `${testid}-hh` : undefined}
      >
        <option value="">HH</option>
        {hours.map((h) => (
          <option key={h} value={h}>{String(h).padStart(2, "0")}</option>
        ))}
      </select>
      <span className="font-mono text-sm text-slate-500">:</span>
      <select
        value={mm || ""}
        onChange={(e) => emit(h12 || "12", e.target.value, ampm || "AM")}
        className="h-9 rounded-md border border-input bg-background px-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-slate-400"
        data-testid={testid ? `${testid}-mm` : undefined}
      >
        <option value="">MM</option>
        {mins.map((m) => (
          <option key={m} value={m}>{m}</option>
        ))}
      </select>
      <select
        value={ampm || "AM"}
        onChange={(e) => emit(h12 || "12", mm || "00", e.target.value)}
        className="h-9 rounded-md border border-input bg-background px-2 text-sm font-mono font-bold focus:outline-none focus:ring-2 focus:ring-slate-400"
        data-testid={testid ? `${testid}-ampm` : undefined}
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
}

export default AmPmTimeInput;
